import type { DiamondType, VaultId } from "../domain/models";

export interface DiamondConfig {
  score: number;
  time: number;
  weight: number;
  color: string;
  glow: string;
  size: number;
  label: string;
}

export const DIAMONDS: Record<DiamondType, DiamondConfig> = {
  SHARD: { score: 10, time: 1, weight: 65, color: "#50dcff", glow: "#168ce8", size: 17, label: "Shard" },
  CUT_DIAMOND: { score: 25, time: 2, weight: 22, color: "#987dff", glow: "#6248dd", size: 20, label: "Cut Diamond" },
  FLAWLESS_DIAMOND: { score: 60, time: 3, weight: 9, color: "#5effad", glow: "#19ad6e", size: 23, label: "Flawless Diamond" },
  SYNDICATE_GEM: { score: 150, time: 5, weight: 3, color: "#ff557d", glow: "#d51f55", size: 26, label: "Syndicate Gem" },
  CROWN_JEWEL: { score: 500, time: 8, weight: 1, color: "#ffd166", glow: "#f09a24", size: 30, label: "Crown Jewel" },
  CLEAN_DIAMOND: { score: 35, time: 0, weight: 4, color: "#f4fbff", glow: "#8ddcff", size: 23, label: "Clean Diamond" },
  FREEZE_DIAMOND: { score: 45, time: 0, weight: 3, color: "#8feaff", glow: "#2d9fff", size: 24, label: "Freeze Diamond" },
  SHIELD_DIAMOND: { score: 40, time: 0, weight: 2, color: "#b8a6ff", glow: "#765cff", size: 24, label: "Shield Diamond" },
  TIME_DIAMOND: { score: 55, time: 5, weight: 2, color: "#ffdc72", glow: "#ff9f1c", size: 25, label: "Time Diamond" },
};

export const VAULTS: Record<VaultId, { name: string; time: number; hazards: number; spawnTarget: number; hazardPenalty: number }> = {
  street: { name: "Street Safes", time: 15, hazards: 1, spawnTarget: 8, hazardPenalty: 1.25 },
  bank: { name: "Bank Vaults", time: 14, hazards: 2, spawnTarget: 7, hazardPenalty: 1.5 },
  casino: { name: "Casino Floor", time: 13, hazards: 3, spawnTarget: 7, hazardPenalty: 1.75 },
  museum: { name: "Museum Heist", time: 13, hazards: 4, spawnTarget: 6, hazardPenalty: 2 },
  server: { name: "Server Vault", time: 12, hazards: 5, spawnTarget: 6, hazardPenalty: 2.25 },
  ghost: { name: "Ghost Vault", time: 12, hazards: 6, spawnTarget: 5, hazardPenalty: 2.5 },
};

export const RANK_THRESHOLDS = [0, 100, 250, 500, 900, 1500, 2400, 3600, 5200, 7200];
